export enum SurgicalTimeLineActions {
  REQUESTED_CANCELLATION_SURGICAL_ORDER = 'REQUESTED_CANCELLATION_SURGICAL_ORDER',
  CANCELED_SCHEDULING_SOLICITATION = 'CANCELED_SCHEDULING_SOLICITATION'
}
